export enum DashboardComponentTypeEnum {
    Top10Shareholders = 'Top10Shareholders',
    Top10ShareholdersChart = 'Top10ShareholdersChart',
    Top10Transactions = 'Top10Transactions',
    PendingTransactions = 'PendingTransactions',
    TotalDispo = 'TotalDispo',
    TotalDispoPercent = 'TotalDispoPercent',
    TotalRegistered = 'TotalRegistered',
    TotalRegisteredPercent = 'TotalRegisteredPercent',
    TotalShareholders = 'TotalShareholders',
    Favorites = 'Favorites',
    FavoriteReports = 'FavoriteReports',
    FavoriteShareholders = 'FavoriteShareholders',
    FileSharing = 'FileSharing',
    GeneralMeetingRegistration = 'GeneralMeetingRegistration',
    GeneralMeetingSettings = 'GeneralMeetingSettings',
    GeneralMeetingInfo = 'GeneralMeetingInfo',
    GeneralMeetingAgenda = 'GeneralMeetingAgenda',
    PersonalInfo = 'PersonalInfo',
    Infomaterial = 'Infomaterial',
    ShareholderCategories = 'ShareholderCategories',
    FactsAndFigures = 'FactsAndFigures',
    Chat = 'Chat',
    ChatControl = 'ChatControl',
    ShareholdersDomicile = 'ShareholdersDomicile',
    DeliveryMethodsStatistic = 'DeliveryMethodsStatistic',
    LiveVoting = 'LiveVoting',
    DeliveryMethod = 'DeliveryMethod',
    Markdown = 'Markdown',
    Presence = 'Presence',
    LiveStream = 'LiveStream',
    LiveStreamVideo = 'LiveStreamVideo',
    VotingMonitor = 'VotingMonitor',
    VirtualSpeakersDesk = 'VirtualSpeakersDesk',
    DmiIntegration = 'DmiIntegration'
}
